import React, { useEffect } from 'react';
import apiClient from '../utils/api';

const StripeRefresh = () => {
    useEffect(() => {
        const refreshOnboarding = async () => {
            try {
                // Request a fresh onboarding link from the backend
                const res = await apiClient.post('/stripe/connect/start-onboarding');
                if (res.data.url) {
                    window.location.href = res.data.url;
                } else {
                    window.location.href = '/settings?stripe=error';
                }
            } catch (err) {
                console.error('Error refreshing Stripe onboarding:', err);
                window.location.href = '/settings?stripe=error';
            }
        };

        refreshOnboarding();
    }, []);

    return (
        <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4">
            <div className="text-center">
                <div className="w-12 h-12 rounded-full border-4 border-indigo-500 border-t-transparent animate-spin mx-auto mb-4"></div>
                <h2 className="text-xl font-bold text-slate-900">Refreshing your session...</h2>
                <p className="text-slate-500">We're generating a new onboarding link for you.</p>
            </div>
        </div>
    );
};

export default StripeRefresh;
